const scrollActiveMobileNavPill = () => {
  document.querySelectorAll('.hotsite-nav-pills__track').forEach((track) => {
    if (track.offsetParent === null) return;

    const activePill = track.querySelector('.hotsite-nav-pill.is-active');
    if (!activePill) return;

    const trackRect = track.getBoundingClientRect();
    const pillRect = activePill.getBoundingClientRect();
    const scrollOffset = (pillRect.left + pillRect.width / 2)
      - (trackRect.left + trackRect.width / 2);

    track.scrollTo({
      left: track.scrollLeft + scrollOffset,
      behavior: 'smooth',
    });
  });
};

const initMobileTopNavigation = () => {
  requestAnimationFrame(scrollActiveMobileNavPill);
};

document.addEventListener('turbolinks:load', initMobileTopNavigation);
document.addEventListener('DOMContentLoaded', initMobileTopNavigation);
